import * as Yup from 'yup';
//utils
import {emailSchema, passwordSchema} from '@/utils/validation';

export type CreateAccountFormValues = {
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	checkbox: boolean;
};

export const initialValues: CreateAccountFormValues = {
	firstName: '',
	lastName: '',
	email: '',
	password: '',
	checkbox: false,
};

export const validationSchema = Yup.object().shape({
	firstName: Yup.string()
		.required('First name is required')
		.trim()
		.matches(/^[a-zA-Zа-яА-ЯіІїЇєЄґҐ]*$/, 'characters.name'),
	lastName: Yup.string().required('Last name name is required'),
	email: emailSchema,
	password: passwordSchema,
	checkbox: Yup.boolean().oneOf([true], 'Terms of Use and the Privacy Policy mast be accept'),
});
